import React from 'react';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { Icon, Tooltip } from 'antd';
import type { EmailExclusionJob } from '../types';
import { getEmailExclusionJobProgressAndText } from '../utils';
import { getStatusColorForProgressBar } from '../../../utils';

type Props = {
  job: EmailExclusionJob,
};

const steps = [
  {
    icon: 'cloud-upload',
  },
  {
    icon: 'security-scan',
    error: errorType => errorType === 'importing',
  },
  {
    icon: 'cluster',
    error: errorType => errorType === 'processing',
  },
  {
    icon: 'carry-out',
    error: errorType => errorType === 'finalizing',
  },
];

export default function EmailExclusionJobStatus(props: Props) {
  const { text, progress, errorType } = getEmailExclusionJobProgressAndText(
    props.job,
  );
  return (
    <Tooltip title={text}>
      <div style={{ paddingLeft: 5, paddingRight: 5, paddingTop: 10 }}>
        <ProgressBar filledBackground="#84cc16" height={4} percent={progress}>
          {steps.map((step, index) => {
            return (
              <Step key={index}>
                {stepProps => (
                  <RenderStep
                    {...step}
                    {...stepProps}
                    error={step.error && step.error(errorType)}
                    index={index}
                    progress={progress}
                  />
                )}
              </Step>
            );
          })}
        </ProgressBar>
      </div>
    </Tooltip>
  );
}

type StepProps = {
  accomplished: boolean,
  index: number,
  progress: number,
  transition: string,
  icon: string,
  error?: boolean,
  tooltip: string,
};

function RenderStep(props: StepProps) {
  const {
    backgroundColor,
    borderColor,
    fontColor,
    inProgress,
  } = getStatusColorForProgressBar({
    accomplished: props.accomplished,
    numOfSteps: steps.length,
    index: props.index,
    progress: props.progress,
    error: props.error,
  });
  return (
    <div
      className={`flex items-center`}
      style={{
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: 14,
        border: `2px solid ${borderColor}`,
        backgroundColor,
      }}
    >
      <Icon
        className={`${inProgress ? 'animation-pulse' : ''}`}
        style={{ fontSize: props.accomplished ? 12 : 14, color: fontColor }}
        type={props.accomplished ? 'check' : props.icon}
      />
    </div>
  );
}
